export const justAskQuantitySet = (state, action) => {

    let currentJustAsk = state.getIn(['workOrderDetails', action.orderId, 'justAskDetails', 'details']);

    currentJustAsk = currentJustAsk.update(currentJustAsk.findIndex((item) => {
        return item.get("transactionTypeId") === action.transactionTypeId;
    }), (item) => {

        if (!item.get('originalQuantity') && item.get('originalQuantity') !== 0) {
            item = item.set('originalQuantity', item.get('quantity'));
        }
        const newQuantity = parseInt(action.quantity);
        const originalQuantity = parseInt(item.get('originalQuantity'));

        item = item
            .set('message', null)
            .set('error', null)
            .set('hasUnsavedChanges', false);

        if (item.get('transactionId') > 0 && newQuantity !== originalQuantity) {
            item = item.set('action', 'update');
        }

        if (item.get('transactionId') > 0 && newQuantity === 0) {
            item = item.set('action', 'update');
        }

        if ((!item.get('transactionId') || item.get('transactionId') <= 0) && newQuantity > 0) {
            item = item.set('action', 'add');
        }

        if (newQuantity === originalQuantity) {
            item = item.set('action', null);
        }

        if (newQuantity !== originalQuantity) {
            item = item.set('hasUnsavedChanges', true);
        }
        item = item.set('quantity', newQuantity);

        return item;
    });

    const justAskWithChanges = currentJustAsk.find((item) => {
        return item.get('hasUnsavedChanges');
    });

    if (justAskWithChanges) {
        state = state.setIn([
            'workOrderDetails', action.orderId, 'justAskDetails', 'hasUnsavedChanges'
        ], true);
    } else {
        state = state.setIn([
            'workOrderDetails', action.orderId, 'justAskDetails', 'hasUnsavedChanges'
        ], false);
    }

    return state.setIn([
        'workOrderDetails', action.orderId, 'justAskDetails', 'details'
    ], currentJustAsk);

};

export const justAskAddFailed = (state, action) => {
    let currentJustAsks = state.getIn(['workOrderDetails', action.orderId, 'justAskDetails', 'details']);

    currentJustAsks = currentJustAsks.update(currentJustAsks.findIndex((item) => {
        return item.get("transactionTypeId") === action.payload.transactionTypeId;
    }), (item) => {

        return item
            .set('error', 'Save failed.')
            .set('loading', false);
    });

    return state.setIn([
        'workOrderDetails', action.orderId, 'justAskDetails', 'details'
    ], currentJustAsks);
};

export const justAskAddStarted = (state, action) => {
    let currentJustAsks = state.getIn(['workOrderDetails', action.orderId, 'justAskDetails', 'details']);

    currentJustAsks = currentJustAsks.update(currentJustAsks.findIndex((item) => {
        return parseInt(item.get("transactionTypeId")) === parseInt(action.request.transactionTypeId);
    }), (item) => {

        return item
            .set('error', null)
            .set('loading', true)
            .set('message', null);
    });

    return state.setIn([
        'workOrderDetails', action.orderId, 'justAskDetails', 'details'
    ], currentJustAsks);
};

export const justAskAddFinished = (state, action) => {
    let currentJustAsks = state.getIn(['workOrderDetails', action.orderId, 'justAskDetails', 'details']);

    currentJustAsks = currentJustAsks.update(currentJustAsks.findIndex((item) => {
        return parseInt(parseInt(item.get("transactionTypeId"))) === parseInt(action.payload.transactionTypeId);
    }), (item) => {

        return item
            .set('message', 'Save Complete.')
            .set('loading', false)
            .set('originalQuantity', action.payload.quantity)
            .set('transactionId', action.payload.transactionId)
            .set('action', null)
            .set('hasUnsavedChanges', false);
    });

    state = state.setIn([
        'workOrderDetails', action.orderId, 'justAskDetails', 'hasUnsavedChanges'
    ], false);

    return state.setIn([
        'workOrderDetails', action.orderId, 'justAskDetails', 'details'
    ], currentJustAsks);
};


// WEBPACK FOOTER //
// ./src/reducers/work-order/justAsk.js